import SetNewPassword from "../../components/Auth/SetNewPassword";
function SetNewPasswordPage() {
    return <SetNewPassword />;
}
export default SetNewPasswordPage;